export default () => ({
  rootContainer: {
    flex: '1 1 160px',
    padding: '0 10px',
  },
  dateColumn: {
    flexBasis: 210,
  },
  label: {
    marginBottom: 4,
    display: 'flex',
    flexDirection: 'column',
  },
  // The date opens the dialog's own calendar, so its input only displays the value.
  dateContainer: {
    cursor: 'pointer',
    '& input': {
      pointerEvents: 'none',
    },
  },
  timeField: {
    margin: '8px 0',
  },
});
